export default "__VITE_ASSET__Blqw8yk5__"